(function () {
  'use strict';

  const CSS_SUB   = '--subscription-price-display';
  const CSS_CASH  = '--cash-price-display';
  const CSS_PTS   = '--cash-points-display';

  function init() {
    const container = document.querySelector('[data-product-container]');
    const checkboxes = document.querySelectorAll('[data-sub-toggle-check]');

    if (!container || !checkboxes.length) return;

    let isActive = new URLSearchParams(location.search).get('view') === 'subscribe';

    if (isActive) {
      checkboxes.forEach(cb => { cb.checked = true; });
      applyState(true, container, checkboxes);
    }

    checkboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        isActive = cb.checked;
        // Sync all checkboxes (desktop + mobile)
        checkboxes.forEach(other => { other.checked = isActive; });
        applyState(isActive, container, checkboxes);
      });
    });

    // Sync cash/points toggles across desktop and mobile groups
    document.querySelectorAll('[data-filter-action="show-cash-price"]').forEach(el => {
      el.addEventListener('change', () => {
        document.querySelectorAll('[data-filter-action="show-cash-price"]').forEach(r => { r.checked = true; });
      });
    });
    document.querySelectorAll('[data-filter-action="show-points-price"]').forEach(el => {
      el.addEventListener('change', () => {
        document.querySelectorAll('[data-filter-action="show-points-price"]').forEach(r => { r.checked = true; });
        // Deactivate subscription when Points is selected
        if (isActive) {
          isActive = false;
          checkboxes.forEach(cb => { cb.checked = false; });
          applyState(false, container, checkboxes);
        }
      });
    });

    // Watch for lazy-loaded tiles to keep empty-state in sync
    new MutationObserver(() => {
      if (isActive) updateEmptyState(container);
    }).observe(container, { childList: true, subtree: true });
  }

  function applyState(active, container) {
    if (active) {
      document.documentElement.style.setProperty(CSS_SUB, 'block');
      document.documentElement.style.setProperty(CSS_CASH, 'none');
      document.documentElement.style.setProperty(CSS_PTS, 'none');

      // Sync Points toggle back to Cash across all groups
      sessionStorage.removeItem('showAsPoints');
      document.querySelectorAll('[data-filter-action="show-cash-price"]').forEach(r => { r.checked = true; });

      container.classList.add('sub-active');
    } else {
      document.documentElement.style.setProperty(CSS_SUB, 'none');

      if (sessionStorage.getItem('showAsPoints')) {
        document.documentElement.style.setProperty(CSS_CASH, 'none');
        document.documentElement.style.setProperty(CSS_PTS, 'block');
      } else {
        document.documentElement.style.setProperty(CSS_CASH, 'block');
        document.documentElement.style.setProperty(CSS_PTS, 'none');
      }

      container.classList.remove('sub-active');
    }

    updateEmptyState(container);
  }

  function updateEmptyState(container) {
    const active = container.classList.contains('sub-active');
    const existing = container.querySelector('[data-sub-empty]');

    if (!active) {
      existing?.remove();
      return;
    }

    const visible = container.querySelectorAll('[data-subscribable="true"]').length;
    if (visible === 0 && !existing) {
      const msg = document.createElement('div');
      msg.setAttribute('data-sub-empty', '');
      msg.className = 'pt-20 pb-52 h3 text-center w-full col-span-2 lg:col-span-3 2xl:col-span-4';
      msg.innerHTML = '<span class="h2">No subscription products available.</span>';
      container.appendChild(msg);
    } else if (visible > 0 && existing) {
      existing.remove();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
